"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _PageSpinner = _interopRequireDefault(require("./PageSpinner.style"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var PageLoader = function PageLoader(_ref) {
  var pastDelay = _ref.pastDelay,
    message = _ref.message,
    error = _ref.error,
    className = _ref.className,
    dataTestId = _ref.dataTestId;
  if (error) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "error-message"
    }, "Sorry, there was a problem loading the page.");
  }
  if (pastDelay) {
    return /*#__PURE__*/_react["default"].createElement(_PageSpinner["default"], {
      className: className,
      "data-testid": dataTestId
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "spinner"
    }), message && /*#__PURE__*/_react["default"].createElement("p", {
      className: "spinner-message"
    }, message));
  }
  return null;
};
PageLoader.defaultProps = {
  className: 'page-spinner',
  error: false,
  /* https://github.com/jamiebuilds/react-loadable#avoiding-flash-of-loading-component */
  pastDelay: true,
  message: '',
  dataTestId: 'page-spinner'
};
PageLoader.propTypes = {
  className: _propTypes.PropTypes.string,
  error: _propTypes.PropTypes.bool,
  pastDelay: _propTypes.PropTypes.bool,
  message: _propTypes.PropTypes.string,
  dataTestId: _propTypes.PropTypes.string
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(PageLoader);